/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterMSmall = createReactComponent("outline", "letter-m-small", "IconLetterMSmall", [["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-0" }]]);

export { IconLetterMSmall as default };
//# sourceMappingURL=IconLetterMSmall.mjs.map
